import { purple } from '@ant-design/colors'
import { NotificationOutlined } from '@ant-design/icons'
import { Iphone } from '@components/Iphone/Iphone'
import { SBFormItemAddon } from '@components/SBFormItemAddon'
import { requiredRule, urlRule } from '@utils/rules'
import { Card, Flex, Form, Input, Space, Splitter, Typography } from 'antd'
import { NamePath } from 'antd/es/form/interface'

const { Text } = Typography

interface BookingLinkSectionProps {}

const BookingLinkSection = ({}: BookingLinkSectionProps) => {
  const baseName: NamePath = ['booking', 'app', 'connectors']
  const bookingLinkName: NamePath = [...baseName, 'bookingLink']
  const bookingLinkUtmName: NamePath = [...baseName, 'bookingLinkUtmSource']

  const form = Form.useFormInstance()
  const linkValue = Form.useWatch(bookingLinkName, form)

  return (
    <Splitter>
      <Splitter.Panel>
        <Flex vertical style={{ padding: 20 }} gap={20}>
          <SBFormItemAddon
            formItemProps={{
              name: bookingLinkName,
              label: 'Booking link',
              rules: [requiredRule(), urlRule()],
              required: true,
            }}
            addonBefore={'Link'}
          >
            <Input size="large" />
          </SBFormItemAddon>
          {linkValue && (
            <Card
              style={{
                backgroundColor: purple[0],
                borderColor: purple[3],
              }}
              styles={{ body: { padding: 16 } }}
            >
              <Space orientation="vertical" className="w-full">
                <Space className="w-full space-between">
                  <Space className="w-full align-items-center" size={8}>
                    <NotificationOutlined style={{ color: purple[3] }} />
                    <Text style={{ color: purple[6] }}>
                      Add an UTM source to identify the traffic origin.
                    </Text>
                  </Space>
                </Space>
                <SBFormItemAddon
                  formItemProps={{
                    name: bookingLinkUtmName,
                    noStyle: true,
                  }}
                  addonBefore={'utm_source'}
                >
                  <Input />
                </SBFormItemAddon>
                <Text style={{ color: purple[6] }} italic>
                  When the utm source attribute is defined, the booking link in
                  the app will be suffixed with this utm source and
                  `&utm_content=APP_USER_ID`
                </Text>
              </Space>
            </Card>
          )}
        </Flex>
      </Splitter.Panel>
      {linkValue && (
        <Splitter.Panel max={'50%'} defaultSize={'40%'}>
          <Iphone link={linkValue} />
        </Splitter.Panel>
      )}
    </Splitter>
  )
}

export { BookingLinkSection }
